const API = {
  dns: "https://avocat-api.vosch.tech",
  ip: "http://192.168.31.60:3039",
  localhost: "http://localhost:3039",
};

const endpoint = API.dns;

export { API, endpoint };
